import React, { createContext, useContext, ReactNode, useState } from 'react';

interface PolicyContextValue {
  manualId: string;
  setManualId: (manualId: string) => void;
}

const PolicyContext = createContext<PolicyContextValue | undefined>(undefined);

interface PolicyProviderProps {
  children: ReactNode;
}

export function PolicyProvider({ children }: PolicyProviderProps) {
  const [manualId, setManualId] = useState<string>('all');

  return (
    <PolicyContext.Provider
      value={{
        manualId,
        setManualId,
      }}
    >
      {children}
    </PolicyContext.Provider>
  );
}

export function usePolicyContext(): PolicyContextValue {
  const context = useContext(PolicyContext);
  if (context === undefined) {
    throw new Error('usePolicyContext must be used within a PolicyProvider');
  }
  return context;
}
